const urlify = function(text = '') {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.replace(urlRegex, function(url) {
        return '<a href="' + url + '" target="blank">' + url + '</a>';
    });
};

export default urlify;
